import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "getting-started-guide",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#getting-started-guide",
        "aria-label": "getting started guide permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Getting Started Guide`}</h1>
    <p>{`Welcome to `}<strong parentName="p">{`Klaviyo - Tiendanube`}</strong>{`! This guide will walk you through the steps to quickly become familiar with your integration.`}</p>
    <h2 {...{
      "id": "requirements",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#requirements",
        "aria-label": "requirements permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`In order to use `}<strong parentName="p">{`Klaviyo`}</strong>{`, you need to be registered as a partner of `}<strong parentName="p">{`Klaviyo`}</strong>{`. If you are not yet, complete the `}<a href="https://www.klaviyo.com/" target="_blank" style={{
            "color": "#000000",
            "background": "url('/img/link.png') no-repeat 100% 0",
            "backgroundSize": "16px 16px",
            "paddingRight": "19px"
          }}><u>{`form`}</u></a>{` by clicking the `}<strong parentName="p">{`Sign up`}</strong>{` option.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Then you will need to have a `}<strong parentName="p">{`Public API Key / Site ID`}</strong>{` and `}<strong parentName="p">{`Private API Keys`}</strong>{`. If you do not have these credentials, you can follow this `}<a href="https://help.klaviyo.com/hc/en-us/articles/115005062267-How-to-Manage-Your-Account-s-API-Keys" target="_blank" style={{
            "color": "#000000",
            "background": "url('/img/link.png') no-repeat 100% 0",
            "backgroundSize": "16px 16px",
            "paddingRight": "19px"
          }}><u>{`guide`}</u></a>{`.`}</p>
      </li>
    </ul>
    <Link to="/installation-onboarding" style={{
      padding: "7.5px 15px",
      backgroundColor: "#000000",
      color: "white",
      borderRadius: "5px"
    }} mdxType="Link">Get started now!</Link>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      